import request from './request'

export function login(username, password) {
  return request.post('/api/auth/login', { username, password })
}

export function logout() {
  return request.post('/api/auth/logout')
}
